import React from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import { Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import HouseboatOutlinedIcon from '@mui/icons-material/HouseboatOutlined';
import LuggageOutlinedIcon from '@mui/icons-material/LuggageOutlined';
import AirplaneTicketOutlinedIcon from '@mui/icons-material/AirplaneTicketOutlined';
import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined';
import DriveEtaOutlinedIcon from '@mui/icons-material/DriveEtaOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';

import { WOW } from 'wowjs';
import { ThemeProvider } from '@mui/material/styles';
import { GlobalTheme } from '../../theme';
import ShowOffer from '../dialog/offer';
import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';

import 'react-quill/dist/quill.snow.css'; // Import the styles
const BASE_MEDIA_URL = 'https://aaryanholidays.in/express/uploads/'; // Update this to the correct base URL if needed


export default function About({ home }) {
    const [openOfferDialog, setOpenOfferDialog] = useState(false);
    const [selectedOfferTitle, setSelectedOfferTitle] = useState('');
    const [slidesData, setslidesData] = useState([]);
    const [offerCont, setOfferCont] = useState([]);
    const closeOfferDIalog = () => {
        setOpenOfferDialog(false); // Close the dialog
    };

    const openOfferDialogWithDetails = (title) => {
        setSelectedOfferTitle(title);
        setOpenOfferDialog(true);
    };

    const iconsMap = useMemo(() => [
        <HouseboatOutlinedIcon  key="houseboat" sx={{ fontSize: '6rem', fill: 'none', stroke: 'currentcolor', strokeWidth: '.03rem' }} />,
        <LuggageOutlinedIcon key="luggage"  sx={{ fontSize: '6rem', fill: 'none', stroke: 'currentcolor', strokeWidth: '.03rem' }} />,
        <AirplaneTicketOutlinedIcon key="airplane"  sx={{ fontSize: '6rem', fill: 'none', stroke: 'currentcolor', strokeWidth: '.03rem' }} />,
        <HotelOutlinedIcon key="hotel"  sx={{ fontSize: '6rem', fill: 'none', stroke: 'currentcolor', strokeWidth: '.03rem' }} />,
        <DriveEtaOutlinedIcon key="drive"  sx={{ fontSize: '6rem', fill: 'none', stroke: 'currentcolor', strokeWidth: '.03rem' }} />,
        <ArticleOutlinedIcon key="article"  sx={{ fontSize: '6rem', fill: 'none', stroke: 'currentcolor', strokeWidth: '.03rem' }} />
    ], []);


    useEffect(() => {

        const fetchAbout = axios.get(`https://aaryanholidays.in/backend/table-data/aaryaan_about`);

        Promise.all([fetchAbout])
            .then(([AboutResponse]) => {
                const filteredData = AboutResponse.data.data.filter(about => about.id !== 1);
                setslidesData(filteredData);
                const data = filteredData[0];

                const offerContData = [];
                for (let i = 1; i <= 6; i++) {
                    offerContData.push({
                        id: i,
                        icon: iconsMap[i - 1],
                        title: data[`offer${i}_title`],
                        brief: data[`offer${i}_description`]
                    });
                }
                setOfferCont(offerContData);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }, [iconsMap]);

    useEffect(() => {
        const wow = new WOW({
            boxClass: 'wow',      // Class name to trigger animations (default: 'wow')
            animateClass: 'animate__animated', // CSS class for animations (default: 'animated')
            offset: 100,           // Distance to the element when triggering the animation
            mobile: true,        // Enable animations on mobile devices
            live: true,          // Check for new elements in the DOM
        });
        wow.init();
    }, []); // Empty dependency array ensures it runs once

    return (
        <React.Fragment>
            <ThemeProvider theme={GlobalTheme}>
                <CssBaseline />

                {slidesData.length > 0 && (
                    <>
                        {slidesData.map((item, index) => (
                            <>
                                <Container key={`service${item.id}-${index}`} maxWidth="xxl" component='section' aria-labelledby='ourServiceHeading whatWeOfferHeading'
                                    sx={{
                                        backgroundColor: GlobalTheme.palette.primary.main
                                    }}
                                >
                                    <Container disableGutters maxWidth='false' sx={{ py: 10 }}>
                                        <Grid item xs display='flex' justifyContent='space-between' flexWrap='wrap'>

                                            <Grid container spacing={3}>
                                                <Grid item xs={12} sm={12} display='flex' flexDirection='column' justifyContent='flex-end' sx={{ mb: 6, textAlign: 'center' }}>
                                                    <Typography id='ourServiceHeading' component='h4' variant='h2' color='white' sx={{ textTransform: 'uppercase', fontWeight: 500, mb: 1 }}>
                                                        Our Services
                                                    </Typography>
                                                    <Typography id='whatWeOfferHeading' component='h3' variant='h4' color='white' sx={{ textTransform: 'none' }}>
                                                        What We Offer For You In Great Packages
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={3}>

                                                {offerCont.map((item, index) => (
                                                    <Grid key={index} item xs={12} sm={4} lg={2}
                                                        sx={{
                                                            mb: { md: 3 },
                                                            position: 'relative',
                                                            overflow: 'hidden',
                                                            borderRadius: 2,
                                                            width: 258,
                                                            height: 348,
                                                        }}>
                                                        <Card elevation={0} key={`offerCont${index}`}
                                                            sx={{
                                                                position: 'relative',
                                                                borderRadius: 2,
                                                                textAlign: 'center',
                                                                height: '100%',
                                                                backgroundColor: 'transparent',
                                                                border: '1px solid',
                                                                borderColor: GlobalTheme.palette.common.white,
                                                                color: GlobalTheme.palette.common.white,
                                                                transition: 'all .2s ease-in',
                                                                "&:hover": {
                                                                    backgroundColor: GlobalTheme.palette.common.white,
                                                                    color: GlobalTheme.palette.common.black
                                                                },

                                                                "&:hover .briefText": {
                                                                    pt: 30
                                                                }
                                                            }}>
                                                            <CardActionArea id={`holiday${item.id}`} key={`offerContentClick${index}`} sx={{
                                                                height: '100%',
                                                                position: 'absolute',
                                                                px: 3,
                                                                pt: { xs: 2, md: 6 },
                                                                transition: 'all .4s ease-in',

                                                                "&:hover": {
                                                                    pt: { xs: 4, md: 3 }
                                                                },

                                                                "&:hover .briefText": {
                                                                    pt: { md: 0 }
                                                                }

                                                            }}
                                                                onClick={() => openOfferDialogWithDetails(item.title)} // Open the dialog with title
                                                            >
                                                                <CardContent component='span' sx={{

                                                                }}>
                                                                    {item.icon}
                                                                    <Typography gutterBottom variant="h4" component="span">
                                                                        <Box component='span' dangerouslySetInnerHTML={{ __html: item.title }} />
                                                                    </Typography>
                                                                    <Typography variant="body2" component='span' sx={{ pt: { xs: 2, md: 12.5 } }} className='briefText' dangerouslySetInnerHTML={{ __html: item.brief }} >
                                                                    </Typography>
                                                                </CardContent>
                                                            </CardActionArea>
                                                        </Card>
                                                    </Grid>
                                                ))}

                                            </Grid>
                                        </Grid>
                                    </Container>
                                </Container >
                            </>
                        ))}
                    </>
                )
                }
                <ShowOffer open={openOfferDialog} handleClose={closeOfferDIalog} title={selectedOfferTitle} isFromOurService={0} />

            </ThemeProvider>
        </React.Fragment >
    )
}